import React from 'react'
import { HeadCard } from '../../structure/card/HeadCard'
import { DatatableMembresia } from './DatatableMembresia'

export const MembresiaPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="Membresias" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>

                    <DatatableMembresia />

                </div>
            </section>
        </div>
    )
}
